import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_467050cc";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_467050cc" };
/** script content **/
require("./radio-group.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex467050cc%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fradio-group%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_467050cc"],
    ctorType: "component",
    outputPath: "components/index467050cc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-radio': getComponent(require("../radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
